import React from "react";
import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  cursor: ${(props: { disabled: boolean }) =>
    props.disabled ? "default" : "pointer"};
  align-items: center;
`;

const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${ParkkiTheme.colors.darkGrey};
  flex: 1;
  justify-content: center;
`;

const ArrowContainer = styled.div`
  display: ${(props: { disabled: boolean }) =>
    props.disabled ? "none" : "flex"};
  color: ${ParkkiTheme.colors.darkGrey};
  justify-content: center;
  align-items: center;
`;

const ShortNameContainer = styled.div`
  padding: 5px 10px;
  color: white;
  background-color: ${(props: { backgroundColor: string }) =>
    props.backgroundColor || "white"};
  text-align: center;
  font-weight: bold;
  line-height: 0.9em;
  max-width: 60px;
  border: 3px solid white;
  border-radius: 5px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
`;

const ValueLabel = styled.div`
  font-size: ${ParkkiTheme.fontSizes.large};
  font-weight: bold;
`;

const RowLabel = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xxsmall};
`;

type Props = {
  open?: boolean;
  disabled: boolean;
  label: string;
  color: string;
  value: string;
};

function ExpandableStatsHeader({
  open,
  disabled,
  color,
  label,
  value,
}: Props): JSX.Element {
  const { formatMessage } = useIntl();

  return (
    <Container disabled={disabled}>
      <LeftContainer>
        <ShortNameContainer backgroundColor={color}>{label}</ShortNameContainer>
      </LeftContainer>
      <RightContainer>
        <ValueLabel>{value}</ValueLabel>
        <RowLabel>
          {formatMessage({
            id: "flowScene.inOutDistribution.expandableStats.header2",
          })}
        </RowLabel>
      </RightContainer>

      <ArrowContainer disabled={disabled}>
        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </ArrowContainer>
    </Container>
  );
}

export default ExpandableStatsHeader;
